import { useAEMFetch,useOriginalAEMFetch } from "@/hooks/common/fetch/useFetch";

export const useEmailApi = async (data) => {
  return await useAEMFetch(`/bin/oversea-base/form/v3/contact-us`).post(data).json();
}

export const useAemToken = async () => {
  return useOriginalAEMFetch(`/libs/granite/csrf/token.json`).get().json();
}